import React, { useEffect, useState } from "react";
import { home } from "services/CategoryService";

import aboutService from "../../services/AboutService";
import Button from "../../componentsTemplate/Button/Button";
import SectionSliderCategories from "components/categories/SectionSliderCategories";
import { getPlans } from "services/PlanService";
import PlanCard from "./PlanCard";
import { FaLock, FaRegCreditCard } from "react-icons/fa";
import Input from "componentsTemplate/Input/Input";
import Label from "componentsTemplate/Label/Label";
import ButtonPrimary from "componentsTemplate/Button/ButtonPrimary";
import { postCardToken, postPayment, getInstallments, getPaymentStatus, getPayment } from "services/MercadoPagoService";
import { showToastError, showToastSuccess } from "utils/toasts";
import { useNavigate } from "react-router-dom";
import Select from "componentsTemplate/Select/Select";
import InputMasked from "componentsTemplate/Input/InputMasked";
import { MdOutlineSave, MdPix, MdSave } from "react-icons/md";
import FrequentlyQuestions from "./components/FrequentlyQuestions";
import ReviewUsers from "./components/ReviewUsers";
import MethodPixPayment from "./MethodPixPayment";
import Slider from "react-slick";
// import todas as imagens do caminho data/images

import imagem1 from "data/sliderPlans/imagem1.jpg";
import imagem2 from "data/sliderPlans/imagem2.jpg";
import imagem3 from "data/sliderPlans/imagem3.jpg";
import imagem4 from "data/sliderPlans/imagem4.jpg";
import imagem5 from "data/sliderPlans/imagem5.jpg";
import imagem6 from "data/sliderPlans/imagem6.jpg";
import imagem7 from "data/sliderPlans/imagem7.jpg";
import imagem8 from "data/sliderPlans/imagem8.jpg";
import imagem9 from "data/sliderPlans/imagem9.jpg";
import PlanCardBenefits from "./PlanCardBenefits";

const AboutUs: React.FC = () => {
  const urlBaseApi = process.env.REACT_APP_BACKEND_API_URL;
  const navigate = useNavigate();

  const [methodPayment, setMethodPayment] = useState<string | null>('credit');

  const [about, setAbout]: any = useState([]);
  const [loading, setLoading] = useState(true);
  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [installmentsDisabled, setInstallmentsDisabled] = useState(true);

  const [plans, setPlans]: any = useState([]);
  const [planBase, setPlanBase]: any = useState(null);
  const [planSelected, setPlanSelected]: any = useState(null);
  const [priceFinal, setPriceFinal]: any = useState(null);
  const [priceInstallment, setPriceInstallment]: any = useState(null);
  const [flagCard, setFlagCard]: any = useState(null);

  const [cardNumber, setCardNumber] = useState("");
  const [cardHolderName, setCardHolderName] = useState("");
  const [expirationMonth, setExpirationMonth] = useState("");
  const [expirationYear, setExpirationYear] = useState("");
  const [securityCode, setSecurityCode] = useState("");
  const [installments, setInstallments] = useState(1);
  const [installmentsOptions, setInstallmentsOptions] = useState([]);

  const [errorSubmit, setErrorSubmit] = useState("");
  const [isVisible, setIsVisible] = useState(false);  

  const [pixResponse, setPixResponse] = useState<any>(null);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);

  const [monthly, setMonthly] = useState(true);

  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };

    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const isMobile = windowWidth < 768;

  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: isMobile ? 1 : 3,
    slidesToScroll: 1,
  };

  const images = [
    imagem1,
    imagem2,
    imagem3,
    imagem4,
    imagem5,
    imagem6,
    imagem7,
    imagem8,
    imagem9,
  ];

  const handleClose = () => {
    setIsVisible(false); // Transição de opacidade
    setTimeout(() => setErrorSubmit(""), 300); // Remove após a animação
  };

  useEffect(() => {
    const plans = getPlans();

    plans.then((response) => {
      setPlans(response);
      setPlanBase(response.find((plan: any) => plan.is_default));
    });

    getAbout();
  }, []);

  const getAbout = async () => {
    setLoading(true); 
    await aboutService
      .getAbout()
      .then((response: any) => {
        setAbout(response.data);
        setLoading(false);
      })
      .catch((error: any) => {
        console.error(error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchCategories();
  }, []);


  const urlBase = process.env.REACT_APP_BACKEND_API_URL;

  const [categories, setCategories]: any = useState < any[] | null > (null);

  const fetchCategories = async () => {
    try {
      const data = await home();
      setCategories(data);
    } catch (error) {
      // Lidar com erros, se necessário
    }
  };

  const handleMethodPayment = (method: string) => () => {
    setMethodPayment(method);

    if (method === 'pix') {
      resetCardCredit();
    } else {

    }
  }

  const handleNameCard = (name: string) => {
    if (name.length < 30) {
      setCardHolderName(name);
    }
  }

  const clickInstallments = () => {
    if (installmentsDisabled) {
      showToastError('Informe o número do cartão para habilitar as parcelas');
    }
  }

  const resetCardCredit = () => {
    setCardNumber('');
    setCardHolderName('');
    setExpirationMonth('');
    setExpirationYear('');
    setSecurityCode('');
    setInstallments(1);
    setInstallmentsDisabled(true);
    setFlagCard(null);
    setInstallmentsOptions([]);

    setIsVisible(false);
    setErrorSubmit('');
  }

  const handleCancel = () => {
    setPlanSelected(null);
    resetCardCredit();

    const element = document.getElementById("plans-card");
    element?.scrollIntoView({ behavior: "smooth" });
  }

  const changePlanSelected = (plan: any) => {
    setCardNumber('');
    setInstallmentsDisabled(true);
    setInstallments(plan.installment_info?.installments || 1);
    setFlagCard(null);

    setPlanSelected(plan);
    setPriceFinal(plan.installment_info?.total_amount || plan.price);
    setPriceInstallment(plan.installment_info?.installment_amount || plan.price);

    setInstallmentsOptions([]);

    setIsVisible(false);
    setErrorSubmit('');

    setPixResponse(null);

    const element = document.getElementById("payment");
    element?.scrollIntoView({ behavior: "smooth" });
  }

  const fetchInstallments = async (data: any) => {
    try {
      
      const installmentsResponse = await getInstallments(data);
      setInstallmentsOptions(installmentsResponse[0].payer_costs);

    } catch (error) {
      // console.error('Erro ao buscar as parcelas', error);
      showToastError('Erro ao buscar as parcelas');
    }
  }

  const handleInstallments = (installments: any) => {
    setInstallments(installments);

    const installment : any = installmentsOptions.find((item: any) => item.installments == installments);

    if (installment) {
      setPriceFinal(installment.total_amount);
      setPriceInstallment(installment.installment_amount);
    }
  }

  const getFormatedPrice = (price: number) => {

    if (!price) return 'R$ -,--';

    const formatter = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });

    return formatter.format(price);
  }
  
  const getFlagCard = (cardNumber: string) => {

    const bin = cardNumber.slice(0, 6);

    if (/^4/.test(bin)) return 'visa';
    if (/^5[1-5]/.test(bin) || /^2(2[2-9]|[3-7]\d)/.test(bin)) return 'master';
    if (/^3[47]/.test(bin)) return 'amex';
    if (/^3(6|8|9)/.test(bin)) return 'diners';
    if (/^6(011|22|4|5)/.test(bin)) return 'discover';

    return null;
  }

  const handleCardNumber = async (e: any) => {

    const cardNumber = e.replace(/\D/g, '');
    setCardNumber(cardNumber);

    if (cardNumber.length !== 16) {
      setInstallmentsDisabled(true);
      return;
    }

    const flag = getFlagCard(cardNumber);

    if (flag) {

      const data : any = {
        'payment_method_id': flag,
        'amount': planSelected.price,
        'bin': cardNumber.slice(0, 6),
      }

      await fetchInstallments(data);
      setFlagCard(flag);
      setInstallmentsDisabled(false);

    } else {

      showToastError('Cartão não suportado');
      setInstallmentsDisabled(true);
      setFlagCard(null);
    }
  }

  const handlePayment = async () => {
      setLoadingSubmit(true);

      // const cardData = {
      //     card_number: "5031433215406351",
      //     security_code: "123",
      //     expiration_month: "11",
      //     expiration_year: "2025",
      //     cardholder: { name: "APRO" },
      // };

      // valide os campos do cartão de crédito como obrigatorios
      if (!cardNumber || !cardHolderName || !expirationMonth || !expirationYear || !securityCode) {
          showToastError('Preencha todos os campos obrigatórios');
          setLoadingSubmit(false);
          return;
      }

      const cardData = {
          card_number: cardNumber,
          security_code: securityCode,
          expiration_month: expirationMonth,
          expiration_year: expirationYear,
          cardholder_name: cardHolderName,
      };
      
      const response = await postCardToken(cardData);      

      const token = response?.id;

      if(token) {
          const paymentData = {
              plan_id: planSelected.id, 
              token: token,
              description: 'Compra de Plano Radar ' + planSelected.name,
              installments: installments,
              payment_method_id: flagCard,
          };

          try {
            const paymentResponse = await postPayment(paymentData);

            if(paymentResponse.status == "approved") {
                showToastSuccess('Pagamento processado com sucesso');
                navigate('/grupo-cidades/selecionar');
            } else {
                setIsVisible(true);
                setErrorSubmit('Pagamento recusado, verifique os dados enviados e tente novamente. Se o erro persistir entre em contato com a nossa equipe.');
            }
          } catch (error) {
            showToastError('Erro ao processar o pagamento, verifique os dados enviados e tente novamente.');
          }
          
      } else {
          setIsVisible(true);
          setErrorSubmit('Erro ao processar o pagamento, verifique os dados enviados e tente novamente.');
      }

      setLoadingSubmit(false);
    };


    useEffect(() => {
      let interval: NodeJS.Timeout;
    
      if (pixResponse?.id) {
        interval = setInterval(async () => {
          try {
            const response = await getPayment({ payment_id: pixResponse.id });
    
            if (response == "approved") {
              showToastSuccess("Pagamento aprovado!");
              clearInterval(interval); // Para a verificação se o pagamento foi aprovado
              navigate("/grupo-cidades/selecionar");
            }
          } catch (error) {
            console.error("Erro ao verificar pagamento PIX:", error);
          }
        }, 20000); // Verifica a cada 30 segundos
      }
    
      return () => clearInterval(interval); // Garante que o intervalo será limpo ao desmontar o componente
    
    }, [pixResponse]);

  return (
    <div>
      {/*begin-history*/}
      <section>
        <div className="flex items-center flex-col lg:flex-row lg:gap-x-10 xl:gap-x-16 bg-[#262626] dark:bg-gray-400 justify-between py-[54px] relative bg-x60light-gray gap-y-10 px-8 md:px-16 xl:px-40 2xl:px-72 sm:w-auto">
          <div className="flex flex-col gap-y-8 flex-1 grow">
            <div>
              <span className="[font-family:'Poppins-Regular',Helvetica] text-white" style={{ background: 'white', color: 'black', borderRadius: '6px', display: 'flex', width: '150px', justifyContent: 'center' }}>
                {/* 5% de cashback */}
                Aproveite já!
              </span>
              <p className="[font-family:'Poppins-ExtraBold',Helvetica] font-extrabold text-transparent text-4xl tracking-[0.80px] leading-[normal]">
                <span className="text-[#a27f59]">Radar </span>
                <span className="text-neutral-800 text-white">Membros </span>
              </p>
            </div>
            <div>
              <p className="w-full [font-family:'Poppins-ExtraBold',Helvetica] text-base text-justify leading-6">

                <span className="[font-family:'Poppins-Regular',Helvetica] text-white">
                  Não perca tempo e faça parte do Radar
                </span>

              </p>

              <p className="w-full [font-family:'Poppins-ExtraBold',Helvetica] text-base text-justify leading-6">
                <span className="[font-family:'Poppins-Regular',Helvetica] text-white">
                  + 6.400 Mulheres
                </span>
              </p>
              <p className="w-full [font-family:'Poppins-ExtraBold',Helvetica] text-base text-justify leading-6">
                <span className="[font-family:'Poppins-Regular',Helvetica] text-white">
                  + 11.700 Negócios
                </span>
              </p>
              <p className="w-full [font-family:'Poppins-ExtraBold',Helvetica] text-base text-justify leading-6">
                <span className="[font-family:'Poppins-Regular',Helvetica] text-white">
                  + 50.000 Conexões
                </span>
              </p>

            </div>
          </div>
          <div className="flex flex-col items-center justify-center gap-[10px] relative flex-1 grow">
            <iframe
              className="shadow-2xl h-36 w-60 sm:h-60 sm:w-96 lg:h-80 lg:w-full rounded-lg"
              width="1024"
              height="720"
              src="https://www.youtube.com/embed/vz3gMi3i2Ck?si=LqLK8mYLGYfH79nK"
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
            ></iframe>
          </div>
        </div>
      </section>
      {/*begin-founder*/}

      <section className="px-8 md:px-16 xl:px-40 2xl:px-72 mt-10">

        <div className="flex flex-col gap-y-8 flex-1 grow" style={{ display: 'flex', alignItems: 'center' }}>
          <div>
            <p className="[font-family:'Poppins-ExtraBold',Helvetica] font-extrabold text-transparent text-4xl tracking-[0.80px] leading-[normal]">
              <span className="text-neutral-800 dark:text-white">Nossos </span>
              <span className="text-[#a27f59]">Planos</span>
            </p>
          </div>
          <div>
            <p className="w-full [font-family:'Poppins-ExtraBold',Helvetica] text-base text-justify leading-6">
              <span className="[font-family:'Poppins-Regular',Helvetica]">
                Os Planos Membros oferecem soluções sob medida para quem busca benefícios exclusivos e personalizados. Com opções variadas, você pode aproveitar dicas de todas as cidades, participar de eventos, acessar classificados e o Radar solidário, além de desfrutar de descontos com parceiros, networking empresarial e oportunidades de viagens. Seja qual for sua escolha, cada plano é projetada para atender as suas necessidades e impulsionar seu sucesso com praticidade e valor!
              </span>
            </p>
          </div>
        </div><br /><br /><br />

        <div className="flex justify-end mb-4">
          
            <label className={`flex gap-2`}>
              <Label>{monthly ? 'Valor estimado mensal' : 'Valor anual'}</Label>
              <div onClick={() => setMonthly(!monthly)}>
                <button
                  type="button"
                  className={`relative w-10 h-6 flex items-center rounded-full p-[4px] transition duration-300 ${monthly ? "bg-primary-500" : "bg-gray-300"}`}
                >
                  <span
                    className={`absolute w-4 h-4 bg-white rounded-full shadow-md transform transition-transform duration-300
                      ${monthly ? "translate-x-4" : "translate-x-0"}`}
                  />
                </button>
              </div>
            </label>

        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-5 gap-2">
          
          <PlanCardBenefits />

          {
            plans.map((plan: any) => (
              <PlanCard key={plan.id} plan={plan} setPlanSelected={changePlanSelected} monthly={monthly} />
            ))
          }
        </div>

      </section >

      <div id="payment"></div>

      {
        planSelected && (
          <section className={`
            px-8 md:px-16 xl:px-40 2xl:px-72 mt-10 
            transform transition-all duration-500 ease-in-out 
            ${planSelected ? 'opacity-100 scale-100' : 'opacity-0 scale-95'}
          `}>
            <div className="border shadow-lg rounded-lg w-full p-2 bg-white">

              <div className="md:flex justify-between items-center">
                <p className="[font-family:'Poppins-ExtraBold',Helvetica] font-extrabold text-transparent text-2xl tracking-[0.80px] leading-[normal]">
                  <span className="text-neutral-800 dark:text-white">Formas de </span>
                  <span className="text-[#a27f59]">Pagamento</span>
                </p>

                <div className="flex flex-wrap gap-x-4">
                  <div 
                    onClick={handleMethodPayment('pix')} 
                    className={`border p-1 flex rounded-lg flex-row items-center cursor-pointer shadow-sm mt-5 md:mt-0 w-full md:w-56 ${methodPayment === 'pix' ? 'border-primary-600 shadow-lg' : ''}`}
                  >
                    <MdPix size={35} className="text-primary-600" />
                    <div className="ml-2">PIX</div>
                  </div>

                  <div 
                    onClick={handleMethodPayment('credit')}  
                    className={`border p-1 flex rounded-lg flex-row items-center cursor-pointer shadow-sm mt-5 md:mt-0 w-full md:w-56 ${methodPayment === 'credit' ? 'border-primary-600 shadow-lg' : ''}`}
                  >
                    <FaRegCreditCard size={35} className="text-primary-600" />
                    <div className="ml-2">Cartão de Crédito</div>
                  </div>
                </div>  

              </div>

              {/* Nome do plano pequeno */}
              <div className="text-sm text-gray-400 mt-2">
                Plano - {planSelected.name}
              </div>

              {
                methodPayment === 'credit' ? (
                  <>
                    <div className="mt-10 grid grid-cols-1 md:grid-cols-3 gap-6">
                      <div className="col-span-1 md:col-span-2  grid grid-cols-1 md:grid-cols-4 gap-6">
                        <div className="col-span-1 md:col-span-2">
                          <Label>
                            {'Número do Cartão'}
                          </Label>
                          <InputMasked
                            placeholder="Número do Cartão"
                            type="text"
                            className="mt-1"
                            mask="9999 9999 9999 9999"
                            onChange={(e) => handleCardNumber(e.target.value)}
                            value={cardNumber}
                          />
                        </div>

                        <div 
                          className="col-span-1"                       
                          onClick={() => clickInstallments()}
                        >
                          <Label>{'Parcelas'}</Label>
                          <Select
                            disabled={installmentsDisabled}
                            className={`mt-1`}
                            style={{ borderRadius: "9999px" }}
                            onChange={(e) => handleInstallments(e.target.value)}
                          >
                            {
                              !installmentsDisabled ? (
                                installmentsOptions.map((item: any) => (
                                  <option key={item.installments} value={item.installments}>
                                    {/* {item.recommended_message} */}
                                    {item.installments}x de {getFormatedPrice(item.installment_amount)}
                                  </option>
                                ))

                              ) : (
                                // <option selected value={1}>{'1x de ' + getFormatedPrice(planSelected.price)}</option>
                                <option selected value={planSelected.installment_info?.installments || 1}>
                                  {(planSelected.installment_info?.installments || 1) + 'x de ' + getFormatedPrice((planSelected.installment_info?.installment_amount || planSelected.price))}
                                </option>
                              )
                            }
                          </Select>
                        </div>

                        <div className="col-span-1">
                          <Label>{'Código de Segurança'}</Label>
                            <InputMasked
                              placeholder="CVV"
                              type="text"
                              className="mt-1"
                              mask="999"
                              onChange={(e) => setSecurityCode(e.target.value)}
                            />
                        </div>

                        <div className="col-span-1 md:col-span-2">
                          <Label>{'Nome no Cartão'}</Label>
                          <Input
                            placeholder="Nome impresso no cartão"
                            type={'text'}
                            className="mt-1"
                            onChange={(e) => handleNameCard(e.target.value)}
                            value={cardHolderName}
                          />
                        </div>

                        <div className="col-span-1">
                          <Label>{'Mês de Vencimento'}</Label>
                          {/* <Input
                            placeholder="MM"
                            type={'text'}
                            className="mt-1"
                            onChange={(e) => setExpirationMonth(e.target.value)}
                          /> */}
                          <Select
                            className="mt-1"
                            style={{ borderRadius: "9999px" }}
                            onChange={(e) => setExpirationMonth(e.target.value)}
                          >
                            <option value="">MM</option>
                            {
                              Array.from({ length: 12 }, (_, i) => i + 1).map((month) => (
                                <option key={month} value={month}>
                                  {
                                    month < 10 ? '0' + month : month
                                  }
                                </option>
                              ))
                            }
                          </Select>
                        </div>

                        <div className="col-span-1">
                          <Label>{'Ano de Vencimento'}</Label>
                          <InputMasked
                            placeholder="AAAA"
                            type="text"
                            className="mt-1"
                            mask="9999"
                            onChange={(e) => setExpirationYear(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="col-span-1 border rounded-lg flex flex-col">
                        <div className="p-1 font-semibold text-lg">
                          Resumo do Pedido
                        </div>

                        <hr />

                        <div className="flex-grow p-1">
                          <p className="text-gray-400 text-xs">Itens do pedido</p>
                          <div className="ms-1 text-gray-600 mt-1">Plano {planSelected.name ?? '-'}</div>

                          <p className="text-gray-400 text-xs mt-3">Forma de pagamento</p>
                          <div className="ms-1 flex mt-1">
                            <FaRegCreditCard className="text-gray-600" size={22}/>
                            <div className="ml-2 text-gray-600">Cartão de Crédito</div>
                          </div>
                        </div>

                        <hr />

                        <div className="p-1">
                          <div className="text-gray-400 text-sm md:text-md">
                            {installments}x de {getFormatedPrice(priceInstallment)} com juros
                          </div>
                          <div className="text-gray-600 flex justify-between mt-1">
                            <div className="text-sm md:text-md">
                              Total a pagar:
                            </div>
                            <div className="font-bold text-md md:text-xl">
                              {getFormatedPrice(priceFinal)}
                            </div>
                          </div>
                        </div>

                      </div>
                    </div>

                    {
                      errorSubmit && (
                        <div
                          className={`flex items-center bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded-lg shadow-md mt-4 transition-opacity duration-300 ease-in-out ${
                            isVisible ? "opacity-100" : "opacity-0"
                          }`}
                          role="alert"
                        >
                          <div className="flex-grow">
                            <strong className="font-bold">Erro no Pagamento:</strong>
                            <span className="block sm:inline ml-2">{errorSubmit}</span>
                          </div>
                          <button
                            onClick={handleClose}
                            className="text-red-700 hover:text-red-900 font-bold ml-4 text-4xl"
                          >
                            ×
                          </button>
                        </div>
                      )
                    }         


                    <div className="flex justify-end mt-10">
                      <Button
                        pattern = "third"
                        className="me-4"
                        type="button"
                        onClick={() => handleCancel()}
                      >
                        Cancelar
                      </Button>

                      {
                        (cardHolderName &&
                          cardNumber &&
                          expirationMonth &&
                          expirationYear &&
                          securityCode &&
                          installments &&
                          !loadingSubmit
                        ) ? (

                          <ButtonPrimary
                            className=""
                            type="button"
                            onClick={() => handlePayment()}
                          >
                            Prosseguir
                            <MdSave size={22} className="ms-2"/>
                          </ButtonPrimary>

                        ) : (

                          <Button
                            pattern = "default"
                            className="cursor-not-allowed"
                            type="button"
                            disabled
                          >
                            Prosseguir
                            <FaLock size={22} className="ms-2"/>
                          </Button>
                        )
                      }
                    </div>
                  </>
                ) : (
                  <MethodPixPayment 
                    pixResponse={pixResponse}
                    setPixResponse={setPixResponse}
                    planSelected={planSelected} 
                    methodPayment={methodPayment} 
                  />
                )
              }
    
            </div>
          </section>
        )
      }      

      <br />
      <br />
      <br />

      <section className="px-8 md:px-16 xl:px-40 2xl:px-72 mt-10">

        <div className="flex flex-col gap-y-8 flex-1 grow" style={{ display: 'flex', alignItems: 'center' }}>
          <div>
            <p className="[font-family:'Poppins-ExtraBold',Helvetica] font-extrabold text-transparent text-4xl tracking-[0.80px] leading-[normal]">
              <span className="text-neutral-800 dark:text-white">O que você vai encontrar na </span>
              <span className="text-[#a27f59]">comunidade do Radar</span>
            </p>
          </div>
          <div>
            <p className="px-0 md:px-40 w-full [font-family:'Poppins-ExtraBold',Helvetica] text-base text-justify leading-6">
              <span className="[font-family:'Poppins-Regular',Helvetica]">
                Com acesso exclusivo a dicas de todas as cidades, eventos imperdíveis, classificados úteis e o <b>Radar Solidário</b>, você também conta com <b>descontos especiais, networking empresarial e oportunidades de viagens</b> incríveis. Um universo de vantagens feito para mulheres empresárias que buscam crescer com suporte, praticidade e <b>conexões de valor!</b>
              </span>
            </p>
          </div>
        </div>

        {/* <SectionSliderCategories
          heading={' '}
          subHeading={''}
          data={categories ?? []}
        /> */}




          <div className="mt-10 mb-20">
          <Slider {...settings}>
            {images.map((item: any, index: any) => (
              <img
                alt="Foto"
                className=""
                src={item}
              ></img>
            ))}
          </Slider>
          </div>

      </section>

      <ReviewUsers />

      <FrequentlyQuestions />                

      <br />
      <br />

    </div >
  );
};
export default AboutUs;
